export function formatTime(seconds: number, likeMinutes = false, showNull = false): string {
    if (!seconds && !showNull) {
        return '--:--';
    }
    const minus = seconds < 0;
    let s = `${Math.floor(Math.abs(seconds)) % 60}`;
    const minutes = Math.floor(Math.abs(seconds) / 60);
    if (likeMinutes) {
        return `${minus ? '-' : ''}${minutes} min`;
    }
    let h = '';
    let m = `${minutes}`;
    if (minutes > 60) {
        h = `${Math.floor(minutes / 60)}`;
        m = `${Math.floor(minutes % 60)}`;
    }
    while (h && h.length < 2) {
        h = `0${h}`;
    }
    while (m.length < 2) {
        m = `0${m}`;
    }
    while (s.length < 2) {
        s = `0${s}`;
    }
    return `${minus ? '-' : ''}${h ? `${h}:` : '' }${m}:${s}`;
}
